module.exports = __webpack_public_path__ + "img/metal_ay@2x.9e9408fa.png";